import { Form, Select } from "antd";
import { ReactElement, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";
import "./edit-preference.scss";
import { PhoneInput } from "react-international-phone";
import { useDispatch } from "react-redux";
import {
  ADD_TO_BREADCRUMB,
  LOADING,
  REMOVE_FROM_BREADCRUMB,
} from "../../store/actions";
import { AxiosResponse } from "axios";
import instance from "../../store/axios";
import toast from "react-hot-toast";
import { useForm } from "antd/lib/form/Form";
import CollapseComponent from "../../components/collapse.component";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import { getStandingDataOptions } from "src/utils/helper/functions";

const EditPerference: React.FC = (): ReactElement => {
  const { accountId, activeKyc } = useParams();
  const [form] = useForm();
  Form.useWatch([], form);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");
  const [addAnotherEmail, setAddAnotherEmail] = useState<boolean>(false);
  const [addAnotherFax, setAddAnotherFax] = useState<boolean>(false);
  const [accountDetails, setAccountDetails] = useState<any>();
  const [standingData, setStandingData] = useState<any>();
  const [hasErrors, setHasErrors] = useState(false);

  useEffect(() => {
    getStandindData();
    getKycApi();

    dispatch({
      type: ADD_TO_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: `Update preferences details`,
            type: "text",
          },
        ],
      },
    });

    return () => {
      dispatch({
        type: REMOVE_FROM_BREADCRUMB,
        payload: {
          breadcrumb: [
            {
              text: `Update preferences details`,
            },
          ],
        },
      });
    };
  }, []);

  const checkFormErrors = () => {
    const errors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);
    setHasErrors(errors);
  };

  const getKycApi = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}?kycId=${activeKyc}`
      );
      setAccountDetails(response.data.data);
      onCorrespondenceChange(
        response?.data?.data?.accountInfo[0]?.correspondencePreferenceId
      );
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/preference/${accountId}/${activeKyc}/edit`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  const onCorrespondenceChange = (value: number): void => {
    value === 67 ? setAddAnotherEmail(true) : setAddAnotherEmail(false);
    value === 68 ? setAddAnotherFax(true) : setAddAnotherFax(false);
  };

  const getStandindData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/standing-data`
      );
      setStandingData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/preference/${accountId}/${activeKyc}/edit`
      );
    }
  };

  const onSubmit = async (values: any): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    values.kycId = accountDetails.accountInfo[0]?.id;

    try {
      await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/prefrence-info/update`,
        values
      );
      toast.success("Personal data updated successfully");
      navigate(
        `/home/business-account/${accountId}/${activeKyc}/details?tab=6${isApproveCase ? "&approve=1" : ""
        }`
      );
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/preference/${accountId}/${activeKyc}/edit${isApproveCase ? "?approve=1" : ""
        }`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  return (
    <div className="edit-preference-container flex flex-col">
      <BreadcrumbComponent />
      {accountDetails?.id && (
        <Form
          className="add-edit-form"
          onFinish={onSubmit}
          initialValues={{
            preferredLanguageId:
              accountDetails?.accountInfo[0]?.preferredLanguageId,
            reportingCurrency:
              accountDetails?.accountInfo[0]?.reportingCurrency,
            correspondencePreferenceId:
              accountDetails?.accountInfo[0]?.correspondencePreferenceId,
            primaryEmail: accountDetails?.accountInfo[0]?.primaryEmail,
            fax: accountDetails?.accountInfo[0]?.fax,
            preferredInvestmentAssetsId:
              accountDetails?.accountInfo[0]?.preferredInvestmentAssetsId,
          }}
          form={form}
          onFieldsChange={() => checkFormErrors()}
        >
          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className=" text-lg font-semibold">Preferences details</h3>
              </div>
            }
          >
            <div className="fields flex justify-space-between wrap">
              <div className="field flex column">
                <Label text="Preferred language" />
                <Form.Item
                  name="preferredLanguageId"
                  rules={[
                    {
                      required: true,
                      message: "Please select Preferred language!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select preferred language"

                    options={[
                      ...getStandingDataOptions(
                        standingData,
                        "language",
                        ["kw", "gc"],
                        false
                      ),
                    ]}
                  />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Preferred reporting currency" />
                <Form.Item
                  name="reportingCurrency"
                  rules={[
                    {
                      required: true,
                      message: "Please select Preferred reporting currency!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select currency"

                    options={[
                      ...getStandingDataOptions(
                        standingData,
                        "PREFERRED_CURRENCY",
                        ["kw", "gc"],
                        false
                      ),
                    ]}
                  />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Correspondence preference" />
                <Form.Item
                  name="correspondencePreferenceId"
                  rules={[
                    {
                      required: true,
                      message: "Please select correspondence preference!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select correspondence preference"
                    onChange={onCorrespondenceChange}

                    options={[
                      ...getStandingDataOptions(
                        standingData,
                        "media",
                        ["kw", "gc"],
                        false
                      ),
                    ]}
                  />
                </Form.Item>
                <span>
                  Trade confirmations will be sent end of every week if
                  residential address, work address, or P.O.Box are selected. By
                  selecting e-mail or fax you will receive the confirmations
                  instantly
                </span>
              </div>

              {addAnotherEmail && (
                <div className="field flex column">
                  <Label text="E-mail" />
                  <Form.Item
                    name="primaryEmail"
                    rules={[
                      {
                        required: true,
                        message: "Please select E-mail!",
                      },
                      {
                        type: "email",
                        message: "Please enter valid email!",
                      },
                    ]}
                  >
                    <CustomInput
                      placeholder="Enter E-mail"
                      value={accountDetails?.accountInfo[0]?.primaryEmail}
                    />
                  </Form.Item>
                </div>
              )}

              {accountDetails?.branch === "SA" && (
                <div className="field flex flex-col mt-3">
                  <Label text="Preferred investment assets" />
                  <Form.Item
                    name="preferredInvestmentAssetsId"
                    rules={[
                      {
                        required: true,
                        message: "Please select preferred investment assets",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select preferred investment assets"

                      options={[
                        ...getStandingDataOptions(
                          standingData,
                          "PREFERRED_CURRENCY",
                          ["kw", "gc"],
                          false
                        ),
                      ]}
                    />
                  </Form.Item>
                </div>
              )}

              {/* {addAnotherFax && (
                <div className="field flex column">
                  <Label text="Fax" />
                  <Form.Item
                    name="fax"
                    rules={[
                      {
                        required: true,
                        message: "Please input Fax!",
                      },
                    ]}
                  >
                    <div className="phone-input">
                      <PhoneInput
                        placeholder="Enter Fax"
                        // value={value}
                        defaultCountry="kw"
                        // onChange={() => setValue("")}
                      />
                      <span className="sub-text">
                        Phone number format: countrycode-phone (Example:
                        +965-00000000)
                      </span>
                    </div>
                  </Form.Item>
                </div>
              )} */}
            </div>
          </CollapseComponent>
          <div className="flex w-full flex-wrap items-center justify-end mt-7 pt-5">
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                onClick={() =>
                  navigate(
                    `/home/business-account/${accountId}/${activeKyc}/details?tab=6${isApproveCase ? "&approve=1" : ""
                    }`
                  )
                }
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
              >
                Cancel
              </button>
              <button
                disabled={hasErrors}
                className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
              >
                Save
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default EditPerference;
